import React from 'react';
import Masonry from './Masonry';
import { getProjectById } from '../data/projects';
import styles from './ProjectPage.module.css';

interface ProjectPageProps {
  projectId: string;
  projectName: string;
}

const ProjectPage: React.FC<ProjectPageProps> = ({ projectId, projectName }) => {
  // Ottieni il progetto specifico dalla configurazione
  const project = getProjectById(parseInt(projectId));
  
  // Se il progetto non esiste, usa un array vuoto
  const masonryItems = project?.media || [];
  
  // Layout a colonna singola: ora e' un dato del progetto, non piu' un array
  // scritto a mano (PIANO.md §5).
  const columns = project?.singleColumn ? 1 : undefined;

  return (
    <div className={styles.projectPage}>
      <div className={styles.masonryContainer}>
        <Masonry
          items={masonryItems}
          ease="power3.out"
          duration={1}
          stagger={0.1}
          animateFrom="bottom"
          scaleOnHover={true}
          hoverScale={0.95}
          columns={columns}
          blurToFocus={false}
          colorShiftOnHover={false}
        />
      </div>
    </div>
  );
};

export default ProjectPage;
